import PropTypes from "prop-types";

import TranslationButtonGroup from "./translations/TranslationButtonGroup";

import "../styles/BreadCrumb.scss";

/**
 * @name BreadCrumb
 * @return {JSX.Element}
 */
const BreadCrumb = ({ label }) => {
    return (
        <div className="crumb-container">
            <div className="breadcrumb-background">
                <h6>{label}</h6>
                <TranslationButtonGroup />
            </div>
        </div>
    );
};

BreadCrumb.propTypes = {
    label: PropTypes.string
};

BreadCrumb.defaultProps = {
    label: ""
};

export default BreadCrumb;
